import { createUpdateQueryPaginationPolicy } from '@repo/frontend-shared/graphql';

export const fetchMoreConfig = {
  // Merged by useInfiniteList's updateQuery — the policy must not
  // append a second time.
  myPartnerUsers: createUpdateQueryPaginationPolicy(),
};
